<template>
    <el-dialog width="40%" title="查看二维码" :visible.sync="viewDetail" @close="closeModel">
        <div class="card">
            <div class="qrcodeShore">
                <div id="qrcode"></div>
            </div>
        </div>
        <div class="btn-css">
            <el-button @click="downLoad">立即下载</el-button>
        </div>

        <!-- <div> -->

        <!--    </div> -->

        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeModel">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";

import { getshoplist, setshoplist } from "@/api/erweima/index";
export default {
    props: {
        logosrc: {
            require: true,
        },
        method: {
            type: Function,
        },
    },
    data() {
        return {
            viewDetail: true,
            loading: false,
        };
    },
    mounted() {
        this.$nextTick(function () {
            this.qrcode();
        });
    },
    methods: {
        closeModel() {
            this.$emit("closeModel");
        },

        qrcode() {
            new QRCode("qrcode", {
                width: 246,
                height: 246,
                text: `${this.logosrc}`,
            });
        },
        downLoad() {
            let myCanvas = document.getElementById("qrcode").getElementsByTagName("canvas");
            let a = document.createElement("a");
            a.href = myCanvas[0].toDataURL("image/png");
            a.href = myCanvas[0].toDataURL("image/png");
            a.download = "二维码";
            a.click();
        },
    },
    components: {},
};
</script>

<style scoped lang="scss">
.card {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.btn-css {
    margin-top: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
